import {apiTemplate} from "@/core/helpers/api.js";

export class Languages {
  static async getLanguages() {
    const userLocale = localStorage.getItem('digitgiftcode-user-locale');

    const response = await apiTemplate(
      {
        "Content-Type": "application/json",
        "Accept-language": userLocale ? userLocale : 'en-gb'
      },
      `query {
        languages {
          code
          flag
          name
        }
      }`
    );

    return await response;
  }
}